var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"circle-button u-flex u-flex--center u-reset-button",class:`circle-button--${_vm.theme} circle-button--size-${_vm.size}`,attrs:{"title":_vm.title}},[(_vm.isLoading)?_c('spinner'):_c('app-icon',{staticClass:"circle-button__icon d-block m-0 p-0",attrs:{"name":_vm.icon,"hidden":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }